export default {
   DOCUMENT:'Document name',
    SELECT_PLACEHOLDER:'Search or select from the list'
}